export default __webpack_public_path__ + "static/media/Cuirass of the Sanguine Disciple.ad620481.jpg";